import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Text = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.lineHeight,
            height: style.lineHeight
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "edit-2"
                }),
                /*#__PURE__*/ _jsxs("g", {
                    strokeWidth: "1",
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    children: [
                        /*#__PURE__*/ _jsx("polyline", {
                            points: "1.5 2.5 1.5 0.5 15.5 0.5 15.5 2.5",
                            fill: "none",
                            stroke: "#ffffff",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("line", {
                            x1: "8.5",
                            y1: "0.5",
                            x2: "8.5",
                            y2: "15.5",
                            fill: "none",
                            stroke: "#ffffff",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("line", {
                            x1: "5.5",
                            y1: "15.5",
                            x2: "11.5",
                            y2: "15.5",
                            fill: "none",
                            stroke: "#ffffff",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            ]
        })
    });
};
export default Text;
